export enum PaymentMethodEnum {
  SMS,
  CHECKOUT,
  QR_CODE,
  DIRECT,
}